document.addEventListener("DOMContentLoaded", function () {
  function waitForElement(selector, { timeout = 5000, root = document.body } = {}) {
    return new Promise(resolve => {
      // 1️⃣ 立即检查是否已存在
      const existing = root.querySelector(selector);
      if (existing) return resolve(existing);
  
      // 2️⃣ 启动 MutationObserver
      const observer = new MutationObserver(() => {
        const el = root.querySelector(selector);
        if (el) {
          clearTimeout(timer);
          observer.disconnect();
          resolve(el);
        }
      });
      observer.observe(root, { childList: true, subtree: true });
  
      // 3️⃣ 超时自动停止监听
      const timer = setTimeout(() => {
        observer.disconnect();
        resolve(null); // 返回 null 表示没找到
      }, timeout);
    });
  }
  
  /**
   * 延迟显示元素（通用逻辑）
   */
  async function delayedShow(selector, delay = 8000) {
    const el = await waitForElement(selector, { timeout: 5000 }); // 最多等15秒
    if (!el) return; // 元素未出现则跳过
  
    el.classList.add('hide');
    setTimeout(() => {
      el.classList.remove('hide');
    }, delay);
  }
  
  // ✅ 调用：每个元素统一一行
  [
    '.needsclick[role="dialog"]',
    '.needsclick[data-testid="animated-teaser"]',
    '#smile-ui-lite-container',
    'shulex-chatbot-lancher'
  ].forEach(selector => delayedShow(selector, 8000));

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "200px", // 预加载距离视口 200px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  window.YGVideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          // 获取内部的 template
          const template = entry.target.querySelector('template');
                
          // 将 template 的内容克隆为 DocumentFragment
          const fragment = template.content.cloneNode(true);
          
          // 先清空 yg-video 内部原有内容
          entry.target.innerHTML = '';
                
          // 将克隆的内容追加到 yg-video
          entry.target.appendChild(fragment);
      }
    });
  }, { 
    rootMargin: "200px", // 预加载距离视口 200px 的视频
  })

  class YGVideo extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.loaderImg()
    }

    loaderImg () {
        // 这里放置自定义逻辑
        window.YGVideoLoader.observe(this)
    }
  }
  if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo)
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.buyItNow()
    }
    buyItNow() {
      this.addEventListener('click', function() {
        let shopBtn = null;
        if(document.querySelector('.shopify-payment-button .shopify-payment-button__more-options')) {
          shopBtn = document.querySelector('.shopify-payment-button .shopify-payment-button__more-options');
        } else {
          shopBtn = document.querySelector('.shopify-payment-button__button');
        }
        shopBtn.click();
      })
    }
  }

  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const { $popupTemplate, fn } = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => { });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => { }
          }
        }))
      }
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGOpenNewsletterPopup extends HTMLElement {
    constructor() {
      super()
      this.newsletterPopup = null
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        const popupButton = document.querySelector('.needsclick ');
        popupButton.click()
      })
    }
  }
  if (!window.customElements.get('yg-open-newsletter-popup')) {
    window.customElements.define('yg-open-newsletter-popup', YGOpenNewsletterPopup)
  }
})
// 公共的写在上面↑↑↑↑↑↑↑↑↑↑

// 组件的写在下面↓↓↓↓↓↓↓↓↓↓
document.addEventListener("DOMContentLoaded", function () {
  class YGForms extends HTMLElement {
    constructor() {
      super()
      this.init();
    }
    init() {
      this.getTab();
    }
    getTab(){
      const $tablist = this.querySelectorAll(".yg-tab");
      const $forms = this.querySelectorAll(".yg-form");
      $tablist.forEach((el,index)=>{
        el.addEventListener("click",function(){
          $tablist.forEach(item=>{
            item.classList.remove("active")
          })
          $forms.forEach(item=>{
            item.classList.remove("active")
          })
          el.classList.add("active")
          $forms[index].classList.add("active")
        })
      })
    }
  }
  if (!window.customElements.get('yg-forms')) {
    window.customElements.define('yg-forms', YGForms)
  }
  class YGSwiperLoop extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.initSwiper()
    }

    initSwiper() {
      new Swiper(this, {
        loop: true,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev'),
        },
        breakpoints: {
          220: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          700: {
            slidesPerView: 2.001,
            spaceBetween: 16,
          },
          1150: {
            slidesPerView: 3.001,
            spaceBetween: 24,
          },
        }
      })
    }
}
if (!window.customElements.get('yg-swiper-loop')) {
    window.customElements.define('yg-swiper-loop', YGSwiperLoop)
}
})
